import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { HomeSelectionListRowProps } from 'features/shared/inventory/selections/home-selections/types/HomeSelectionListRowProps';
import type { InventoryItem } from 'core/types';
import 'features/shared/inventory/InventoryProducts.scss';

const na = (val: string) => (val.trim() !== '' ? val.trim() : 'N/A');

/**
 * Desktop options row inside an accordion section grouped by
 * `optionCategory` (inventory group 67). Shows only the title
 * (`description`, left) and Notes (`location`, right) — no pills, hex
 * value, or click-through per the approved prototype.
 */
const HomeSelectionListRowDesktop: React.FC<HomeSelectionListRowProps> = ({
  title,
  notes
}) => {
  return (
    <IonItem lines="none" className="hk-desktop-home-selection-item">
      <IonLabel className="hk-desktop-home-selection-item-body">
        <IonText className="hk-desktop-home-selection-item-name">
          <p>{na(title)}</p>
        </IonText>
        {notes.trim() !== '' && (
          <IonText className="hk-desktop-home-selection-item-body-field">
            <p>
              <span className="hk-desktop-home-selection-item-body-field-label">
                Notes:
              </span>{' '}
              {notes.trim()}
            </p>
          </IonText>
        )}
      </IonLabel>
    </IonItem>
  );
};

export default HomeSelectionListRowDesktop;

export function inventoryItemToHomeSelectionRowProps(
  item: Pick<InventoryItem, 'name' | 'attributes'>
): HomeSelectionListRowProps {
  return {
    title: item.name ?? '',
    notes: item.attributes?.location ?? ''
  };
}
